module.exports = __webpack_public_path__ + "static/media/computerVision.221ca7b5.png";